import slider from '../helpers/slider';
import matchHeight from '../helpers/matchHeight';

class ProductTestimonials {
  init() {
    document.querySelectorAll('[data-product-testimonials] .product-testimonials__items').forEach((reviews:HTMLElement) => this.load(reviews));
    matchHeight.init('[data-product-testimonials] .product-testimonials-item__copy');
  }

  load(reviews:HTMLElement) {
    slider.init(reviews, {
      // @ts-ignore
      prevButton: document.querySelector('[data-product-testimonials-prev-button]'),
      nextButton: document.querySelector('[data-product-testimonials-next-button]'),
      gutter: 10,
      touch: false,
      autoplay: true,
      responsive: {
        1024: {
          items: 3,
          controls: true,
          disable: false
        }
      }
    });
  }

}

export default new ProductTestimonials();